export const isMobileDevice = () => {
    const ua = navigator.userAgent || '';
    const uaMatch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const smallScreen = window.matchMedia('(max-width: 768px)').matches;
    return uaMatch || (touch && smallScreen);
};
